import { render, staticRenderFns } from "./request-statistics.vue?vue&type=template&id=38aad594&scoped=true"
import script from "./request-statistics.vue?vue&type=script&lang=js"
export * from "./request-statistics.vue?vue&type=script&lang=js"
import style0 from "./request-statistics.vue?vue&type=style&index=0&id=38aad594&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38aad594",
  null
  
)

export default component.exports